import { Button } from '@common/components/button';
import Icon from '@common/components/icon';
import Stack from '@common/components/stack';
import ModalWindow from '@common/components/modal/modal-window';
import Video from '@common/components/video';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@common/hooks';

const LandingPage = () => {
  const { t } = useTranslation();
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const defaultLanguage = useAppSelector(
    (state) => state.loggedUser.user.language_locale
  );

  const handleOpenVideoModal = () => {
    setIsVideoModalOpen(true);
  };

  const handleCloseVideoModal = () => {
    setIsVideoModalOpen(false);
  };

  return (
    <div className="!tw-flex !tw-bg-white !tw-w-full">
      <div className="tw-flex tw-flex-1 tw-justify-center tw-items-center">
        <div className="tw-flex tw-flex-col tw-gap-10 tw-w-[55%]">
          <div className="!tw-flex !tw-flex-col !tw-gap-3">
            <div className="tw-text-base tw-font-semibold tw-text-gray-muted tw-uppercase tw-tracking-widest">
              {t('performance:introducing_performance')}
            </div>
            <div className="tw-text-gray-textDarkest tw-text-[54px] tw-font-medium tw-leading-[64px]">
              {t('performance:evaluations_made_simple')}
            </div>
            <div className="tw-text-gray-textDark tw-text-lg tw-font-medium tw-leading-[28px]">
              {t('performance:create_and_manage_evaluations')}
            </div>
          </div>
          <div className="!tw-flex !tw-flex-col !tw-gap-5">
            <Stack direction="row" gap={4}>
              <div className="!tw-flex !tw-items-center !tw-justify-center !tw-h-8 !tw-rounded-md !tw-bg-green-dark">
                <Icon
                  type="file_02_bolt"
                  isFilled
                  color="white"
                  size={20}
                  className="tw-p-1"
                />
              </div>
              <Stack direction="column" gap={1}>
                <div className="tw-text-gray-textDark tw-text-lg tw-font-medium">
                  {t('performance:create_evaluations')}
                </div>
                <div className="tw-text-gray-textParagraph tw-text-base tw-font-normal">
                  {t('performance:design_performance_reviews')}
                </div>
              </Stack>
            </Stack>
            <Stack direction="row" gap={4}>
              <div className="!tw-flex !tw-items-center !tw-justify-center !tw-h-8 !tw-rounded-md !tw-bg-red-dark">
                <Icon
                  type="file_02_check"
                  isFilled
                  color="white"
                  className="tw-p-1"
                  size={20}
                />
              </div>
              <Stack direction="column" gap={1}>
                <div className="tw-text-gray-textDark tw-text-lg tw-font-medium">
                  {t('performance:review_evaluations')}
                </div>
                <div className="tw-text-gray-textParagraph tw-text-base tw-font-normal">
                  {t('performance:gain_visibility_into_progress')}
                </div>
              </Stack>
            </Stack>
            <Stack direction="row" gap={4}>
              <div className="!tw-flex !tw-items-center !tw-justify-center !tw-h-8 !tw-rounded-md !tw-bg-yellow-dark">
                <Icon
                  type="file_02_bar_graph"
                  color="white"
                  size={20}
                  className="tw-p-1"
                />
              </div>
              <Stack direction="column" gap={1}>
                <div className="tw-text-gray-textDark tw-text-lg tw-font-medium">
                  {t('performance:generate_reports')}
                </div>
                <div className="tw-text-gray-textParagraph tw-text-base tw-font-normal">
                  {t('performance:discover_trends_and_strengths')}
                </div>
              </Stack>
            </Stack>
          </div>
          <div className="!tw-flex !tw-flex-row !tw-gap-3">
            <Button
              type="primary"
              size="large"
              className="!tw-w-full"
              onClick={() => {
                window.Intercom?.(
                  'showNewMessage',
                  t('performance:intercom_performance_review')
                );
              }}
            >
              {t('performance:upgrade_plan')}
            </Button>
            {defaultLanguage === 'nl' && (
              <Button
                type="inverted"
                size="large"
                icon="play_arrow"
                iconColor="grey"
                className="!tw-w-full tw-text-center tw-justify-center tw-text-textDark"
                onClick={handleOpenVideoModal}
              >
                {t('performance:see_in_action')}
              </Button>
            )}
          </div>
        </div>
      </div>
      <div className="tw-top-6 tw-flex tw-justify-center tw-items-center tw-flex-1">
        <img
          src={`/static/images/performance-landing-image-${defaultLanguage}.png`}
          alt="Performance"
          className="tw-p-6 tw-object-cover tw-h-[85vh]"
        />
      </div>

      <ModalWindow
        show={isVideoModalOpen}
        onHide={handleCloseVideoModal}
        size="large"
        className="modal--video !tw-overflow-hidden"
      >
        <div className="!tw-overflow-hidden">
          <Video
            path="https://www.youtube.com/watch?v=-DYGyJxZPi8"
            className="tw-w-full tw-h-full"
            playing
          />
        </div>
      </ModalWindow>
    </div>
  );
};

export default LandingPage;
